export const log = require('debug')('swtch')
